import { translate } from "@atoms/atom-client/i18n";

export enum CaseVariant {
  COVER_OUTSIDE = "cover_outside",
  COVER_INSIDE = "cover_inside",
}

/**
 * German labels. The value is stored in `PositionInfo.variant` and printed in
 * the PDF header: use {@link getCaseVariantLabelDe} for stored values.
 */
export const CASE_VARIANT_LABELS_DE: Readonly<Record<CaseVariant, string>> = {
  [CaseVariant.COVER_OUTSIDE]: "Deckel außen",
  [CaseVariant.COVER_INSIDE]: "Deckel innen",
};

/** Variant labels in the UI language (read on access). */
export const CASE_VARIANT_LABELS: Readonly<Record<CaseVariant, string>> = {
  get [CaseVariant.COVER_OUTSIDE]() {
    return translate(
      "app.manufacturer.caseVariants.coverOutside",
      CASE_VARIANT_LABELS_DE[CaseVariant.COVER_OUTSIDE],
    );
  },
  get [CaseVariant.COVER_INSIDE]() {
    return translate(
      "app.manufacturer.caseVariants.coverInside",
      CASE_VARIANT_LABELS_DE[CaseVariant.COVER_INSIDE],
    );
  },
};

export function getCaseVariantLabelDe(variant: string): string {
  return CASE_VARIANT_LABELS_DE[variant as CaseVariant] ?? variant;
}
